import { ReactElement } from 'react'

import { UserPermissionsState } from '../../redux/reducers/initialState'

export type KeyInfo = {
  keyId: string
  keyName: string
  aadRevocation: string
  lastUsed?: Date
  timestamp?: Date
  rowKey?: string
  continuationToken: string
}

export type SearchKeyInfo = {
  keyId?: string
  keyName?: string
  aadRevocation?: string
  continuationToken?: string
}

export type NavItem = {
  id: string
  to: string
  label: string
  requiredPermissions?: (keyof UserPermissionsState)[]
  icon: ReactElement
}

export const isNavItem = (item: NavItem | NavItemGroup): item is NavItem => {
  return (item as NavItem).to !== undefined
}

export type NavItemGroup = {
  id: string
  name: string
  items: (NavItem | NavItemGroup)[]
  icon: ReactElement
}

export type Language = {
  value: string
  label: string
  disabled: boolean
}
